<script>
import { Dialog } from 'element-ui';

// 修改默认值
// Dialog.props.modalAppendToBody.default = false
// Dialog.props.AppendToBody.default = true
export default {
  mixins: [Dialog],
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
  padding: 16px 20px 35px;
}
.el-dialog__header {
  font-size: 18px;
  padding: 19px 20px 10px;
  line-height: 25px;
  .el-dialog__title {
    color: $theme-textmain;
  }
  .el-dialog__headerbtn {
    top: 25px;
    right: 20px;
    .el-dialog__close {
      color: $theme-textplaceholder;
    }
  }
}
.el-dialog__footer {
  padding: 12px 20px 14px;
}
/deep/ .desc{
  line-height: 44px;
  font-size: 14px;
  color: $theme-textnormal;
}
</style>